import 'antd/dist/antd.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import './App.css'
import './header.css'
import './history.css'
import { Input, message, Button, Result, Drawer, List, Divider, Select, Rate, Pagination, Checkbox, Dropdown, Menu } from 'antd'
import ImageGallery from 'react-image-gallery'
import { TranslationOutlined, UserOutlined, ArrowRightOutlined, CheckCircleOutlined, StopOutlined, LoadingOutlined, SisternodeOutlined, PictureOutlined, WarningOutlined } from '@ant-design/icons'
import React, { Component } from 'react'
import _ from 'lodash'
import axios from 'axios'
import DefaultItems from './default-items'
import franc from 'franc-min'
import texts from './texts'
import dateformat from 'dateformat'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

// const API_HREF = (process.env.NODE_ENV === 'production') ? (process.env.PUBLIC_URL +'/api') : 'https://lab.aminer.cn/cogview/api'// 'http://localhost:19385'
// const API_HREF = 'https://wudao.aminer.cn/api/cogview'
//const API_HREF = 'https://agc.platform.baai.ac.cn/api/cogview'
const NEW_API_HREF = 'https://models.aminer.cn/api/textimage'
const API_HREF = 'https://models.aminer.cn/api/cogview'
const IMG_URL = 'https://cogview.cn-wlcb.ufileos.com'

// ES API 服务地址
const ES_API_SERVER = 'https://models.aminer.cn/api'

const USERNAME_CACHE_KEY = 'cogview.v1.username'

const { Option } = Select

const input_mode_ids = Object.keys(texts).filter((key) => key.startsWith("input_mode_"))

const continue_change = false;
export default class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'login',
      username: localStorage.getItem(USERNAME_CACHE_KEY) || '',
      userId: null,
      query: '一只戴墨镜的猫',
      input_mode: '高清摄影',
      loading: false,
      defaultItems: [],
      recommendItems: [],
      task: undefined,
      newTask: undefined,
      displayHistory: false,
      historyTasks: [],
      historyInput: '',
      historyPage: 1,
      historyTotal: 0,
      waitingTasks: [],
      waitingTime: 0,
      enableTrans: false,
      lang: (navigator.language || navigator.userLanguage) === 'en' ? 'en' : 'zh',
      currentImgIndex: 0,
      humanRating: [],
      myRating: [],
      my_history_checked: false,
      my_history_disabled: false,
      dropdownRecommendList: [],
      recommendListDropmenuVisible: false,
      // 是否第一次以带id参数的方式进入cogview页面
      isFirstIntoPageById: false,
      // 用户是否选择了搜索的推荐词
      isSelectedRecommendWd: false
    }
    this.poll_process = undefined
    this.poll_interval = 5
    this.last_submit_time = 0

    this.imageGallery = React.createRef()
    this.imageGalleryNew = React.createRef()
    this.handleContinue = this.handleContinue.bind(this)
  }

  async componentDidMount() {
    // 获取查询ID
    const queryId = this.parseUrl('id')
    // 获取跳转过来的图片地址
    const defaultImg = this.parseUrl('imgSrc')
    // Initialize an agent at application startup.
    const fpPromise = FingerprintJS.load()
    // Get the visitor identifier when you need it.
    const fp = await fpPromise
    const fingerprint = await fp.get()
    // Print the 32bit hash id to the console
    // console.log(fingerprint);
    this.setState({ userId: fingerprint.visitorId })

    this.refreshWaitingTasks()
    this.getDefalutImgs(queryId, null, defaultImg)
    this.refresh_process = setInterval(() => {
      this.refreshWaitingTasks()
      // this.refreshHistoryTasks()
    }, 5000)

    // 更新第一次访问页面标志
    this.setState({ isFirstIntoPageById: queryId ? true : false })

    /* setTimeout(() => {
      console.log('this.currentImgIndex start => ', this.state.currentImgIndex)
      this.setState({ currentImgIndex: 2 })
      console.log('this.currentImgIndex end => ', this.state.currentImgIndex)
    }, 1000); */

    window.addEventListener('mouseup', this.handleMouseUp.bind(this), false)
  }

  componentDidUpdate(preProps, preState) {
    if (this.state.historyPage !== preState.historyPage) {
      this.refreshHistoryTasks(this.state.my_history_checked)
    }
    if (this.state.userId !== preState.userId && this.state.userId && !this.parseUrl('id')) {
      this.getDefalutImgs()
    }
  }

  componentWillUnmount() {
    if (this.poll_process) clearInterval(this.poll_process)
    if (this.refresh_process) clearInterval(this.refresh_process)
  }

  // 解析从悟道主页跳转过来的url，从url解析出query
  parseUrl(key) {
    const url = new URL(window.location.href)
    const query = url.searchParams.get(key)
    return query
  }

  // 获取默认图片
  async getDefalutImgs(id, wd, defaultImg) {
    let items = [], resp = null
    // 如果从图库跳转过来，则直接展示图库中图片
    if (id) {
      try {
        resp = await axios.get(`${ES_API_SERVER}/wudao/${id}/doc-list?type=cogview`, { timeout: 1000 * 60 * 8 })
      } catch (err) {
        console.log("请求超时----")
        return {}
      }
      if (resp.data.code !== '0') {
        return message.error(this.t('service_err', { err: '从ES中获取cogview数据失败' }))
      }

      // 设置默认的图片
      items = resp.data.data.list.map((item) => {
        return { original: item._source.output, description: item._source.input, isEsSource: true }
      })

      // 设置默认的图片描述
      this.setState({ query: (resp.data.data.list.length > 0) ? resp.data.data.list[0]._source.input : '' })

      // 获取默认图片路径
      const imgIndex = items.findIndex((item) => { return item.original.indexOf(defaultImg) > -1 })

      // 设置当前图片风格
      this.setState({ input_mode: (items.length > 0) && resp.data.data.list[0]._source.style !== '0' ? resp.data.data.list[0]._source.style : '高清摄影', currentImgIndex: imgIndex === -1 ? 0 : imgIndex })
    } else if (wd) { // 如何用户点击推荐词，则直接展示推荐词的图片
      try {
        resp = await axios.get(`${ES_API_SERVER}/wudao/input/doc-list?type=cogview&input=${wd}`, { timeout: 1000 * 60 * 8 })
      }
      catch (err) {
        console.log("请求超时----")
        return {}
      }
      if (resp.data.code !== '0') {
        return message.error(this.t('service_err', { err: '从ES中获取cogview数据失败' }))
      }
      // 设置默认的图片
      items = resp.data.data.list.map((item) => {
        return { original: item._source.output, description: item._source.input, isEsSource: true }
      })

      // 设置默认的图片描述
      this.setState({ query: wd })
      // 设置当前图片风格
      this.setState({ input_mode: items.length > 0 && resp.data.data.list[0]._source.style !== '0' ? resp.data.data.list[0]._source.style : '高清摄影' })
    } else {  // cogview原有逻辑
      resp = await axios.post(`${API_HREF}/recommend`, { userid: this.state.userId })
      items = resp?.data?.result || []
      if (items.length < 12) {
        let len = 12 - items.length
        let default_items = DefaultItems.slice(0, len)
        items = items.concat(default_items)
      }
    }

    this.setState({ recommendItems: [...items] })
    const humanRating = JSON.parse(JSON.stringify(items))
    const myRating = []
    items.forEach((item) => {
      myRating.push(item.score_user || -1)
    })
    this.setState({ humanRating, myRating })

    return items;
  }

  refreshWaitingTasks() {
    axios
      .get(`${API_HREF}/waiting`)
      .then((resp) => {
        this.setState({ waitingTasks: resp.data.tasks, waitingTime: Math.ceil(resp.data.estimate_time / 60) })
      })
      .catch((err) => {
        console.log(this.t('service_err', { err }))
      })
  }

  refreshHistoryTasks(is_my_history = false) {
    let historyUrl
    const userId = this.state.userId
    if (is_my_history) {
      historyUrl = `${API_HREF}/history?query=${this.state.historyInput}&userid=${userId}&page=${this.state.historyPage}`
    } else {
      historyUrl = `${API_HREF}/history?query=${this.state.historyInput}&page=${this.state.historyPage}`
    }
    axios
      .get(historyUrl)
      .then((resp) => {
        this.setState({ historyTasks: resp.data.tasks, historyTotal: +resp.data.count })
      })
      .catch((err) => {
        console.log(this.t('service_err', { err }))
      })
  }

  t(code, dict) {
    let text = texts[code][this.state.lang]
    if (dict) {
      Object.keys(dict).forEach((key) => {
        text = text.replace('%' + key, dict[key])
      })
    }
    return text
  }

  datestr(t) {
    return dateformat(new Date(t), 'yyyy/mm/dd H:MM:ss')
  }

  detectTrans = _.debounce(() => {
    // console.log('length', this.state.query.trim().length)
    if (this.state.query.trim().length < 5) this.setState({ enableTrans: false })
    const lang = franc(this.state.query + ' ')
    this.setState({ enableTrans: lang !== 'cmn' && lang !== 'und' })
  }, 500)

  translate() {
    this.setState({ loading: true })
    axios
      .post(`${API_HREF}/translate`, { query: this.state.query })
      .then((resp) => {
        const data = resp.data
        if (data.status) {
          this.setState({ loading: false, enableTrans: false, query: data.text })
          message.success(this.t('translation_succeed'))
        } else {
          this.setState({ loading: false, enableTrans: false })
          message.warning(this.t('translation_failed') + data.message)
        }
      })
      .catch((err) => {
        this.setState({ loading: false, enableTrans: false })
        message.error(this.t('service_err', { err }))
      })
  }

  updateHistory(displayHistory) {
    this.setState({ loading: true })
    let historyUrl
    const userId = this.state.userId
    if (this.state.my_history_checked) {
      historyUrl = `${API_HREF}/history?query=${this.state.historyInput}&userid=${userId}&page=${this.state.historyPage}`
    } else {
      historyUrl = `${API_HREF}/history?query=${this.state.historyInput}&page=${this.state.historyPage}`
    }
    axios
      .get(historyUrl)
      .then((resp) => {
        this.setState({ loading: false, historyTasks: resp.data.tasks, displayHistory, historyTotal: +resp.data.count })
        message.info(this.t('load_history_records', { size: resp.data.tasks.length }))
      })
      .catch((err) => {
        message.error(this.t('service_err', { err }))
        this.setState({ loading: false })
      })
  }

  onMyHistoryChange = (e) => {
    // console.log('checked = ', e.target.checked);
    this.setState({
      my_history_checked: e.target.checked,
      historyPage: 1,
    })
    this.refreshHistoryTasks(e.target.checked)
  }

  showHistory() {
    this.updateHistory(true)
    // if (this.state.historyTasks.length === 0) {
    //   this.updateHistory(true)
    // } else {
    //   this.setState({displayHistory: true})
    // }
  }

  poll(task) {
    if (task === undefined) task = this.state.task
    if (task === undefined || task.status === 'Succeed' || task.status === 'Fail') return
    if (this.poll_process) clearInterval(this.poll_process)
    this.poll_process = setInterval(() => {
      axios
        .get(`${API_HREF}/get/${task._id}?userid=${this.state.userId}`)
        .then((resp) => {
          const task = resp.data.task
          if (task.status === 'Succeed' || task.status === 'Fail') {
            clearInterval(this.poll_process)
            if (task.status === 'Succeed') message.success(this.t('generation_succeed_all_img', { size: task.num_images }))
          }
          if (task._id !== this.state.task._id || task.status !== this.state.task.status) this.setState({ task })
        })
        .catch((err) => {
          message.error(this.t('service_err', { err }))
          clearInterval(this.poll_process)
        })
    }, this.poll_interval * 1000)
  }

  pollNew(task) {
    if (task === undefined) task = this.state.task
    if (task === undefined || task.status === 'Succeed' || task.status === 'Fail') return
    if (this.poll_process_new) clearInterval(this.poll_process_new)
    this.poll_process_new = setInterval(() => {
      axios
        .get(`${NEW_API_HREF}/get/${task._id}?userid=${this.state.userId}`)
        .then((resp) => {
          const task = resp.data.task
          if (task.status === 'Succeed' || task.status === 'Fail') {
            clearInterval(this.poll_process_new)
          }
          if (task._id !== this.state.task._id || task.status !== this.state.task.status) this.setState({ newTask: task })
        })
        .catch((err) => {
          message.error(this.t('service_err', { err }))
          clearInterval(this.poll_process_new)
        })
    }, this.poll_interval * 1000)
  }

  async generate(force_refresh) {
    if (force_refresh === undefined) force_refresh = false
    if (this.poll_process) clearInterval(this.poll_process)
    if (this.state.username.trim().length === 0) {
      message.warning(this.t('input_name_not_empty'))
      this.setState({ task: undefined })
    } else if (this.state.query.trim().length < 2 || this.state.query.trim().length > 30) {
      message.warning(this.t('input_length_not_valid', { size: this.state.query.trim().length }))
      this.setState({ task: undefined })
    } else if (Date.now() - this.last_submit_time < 5000) {
      message.warning(this.t('submit_too_fast'))
      this.setState({ task: undefined })
    } else {
      // 如果用户直接输入，没有选择推荐词，则先查询es中是否有数据，没有则再重新生成
      if (!this.state.isSelectedRecommendWd && !this.state.task) {
        const items = await this.getDefalutImgs(null, this.state.query)
        if (items && Array.isArray(items) && items.length > 0) {
          this.setState({ isSelectedRecommendWd: true, task: undefined })
          return;
        }
      }
      this.last_submit_time = Date.now()
      localStorage.setItem(USERNAME_CACHE_KEY, this.state.username)
      this.setState({ loading: true, task: undefined })
      let realQuery = this.state.query + (this.state.input_mode !== '默认' ? '，' + this.state.input_mode : '')
      axios
        .post(`${API_HREF}/generate`, {
          username: this.state.username,
          query: realQuery,
          force_refresh,
          lang: this.state.lang,
          userid: this.state.userId,
        })
        .then((resp) => {
          const status = resp.data.status
          if (!status) {
            message.info(`${this.t('request_failed')}${resp.data.message}`)
            this.setState({ loading: false })
            return
          }
          const task_id = resp.data._id
          axios
            .get(`${API_HREF}/get/${task_id}?userid=${this.state.userId}`)
            .then((resp) => {
              const task = resp.data.task
              if (task.status === 'Succeed') message.success(this.t('generation_succeed_all_img', { size: task.num_images }))
              const myRating = [-1, -1, -1, -1, -1, -1, -1, -1]
              task.score_list.forEach((item) => {
                myRating.push(item.score_user || -1)
              })
              this.setState({ loading: false, task, myRating, currentImgIndex: 0, humanRating: task.score_list, isFirstIntoPageById: false })
              this.poll(task)
            })
            .catch((err) => {
              message.error(this.t('service_err', { err }))
              this.setState({ loading: false })
            })
        })
        .catch((err) => {
          message.error(this.t('service_err', { err }))
          this.setState({ loading: false })
        })

      // 新版效果
      axios
        .post(`${NEW_API_HREF}/generate`, {
          username: this.state.username,
          prompt: realQuery,
          userid: this.state.userId,
          num_images_per_prompt: 1,
        })
        .then((resp) => {
          const status = resp.data.status
          if (!status) {
            return
          }
          const task_id = resp.data._id
          axios
            .get(`${NEW_API_HREF}/get/${task_id}?userid=${this.state.userId}`)
            .then((resp) => {
              const task = resp.data.task

              this.setState({ newTask: task })
              this.pollNew(task)
            })
            .catch((err) => {
              message.error(this.t('service_err', { err }))
              this.setState({ loading: false })
            })
        })
        .catch((err) => {
          message.error(this.t('service_err', { err }))
          this.setState({ loading: false })
        })
    }
  }

  // 搜索历史
  onSearch(value) {
    setTimeout(() => {
      this.setState({ historyInput: value })
      this.refreshHistoryTasks(this.state.my_history_checked)
    }, 0)
  }

  // 图片切换
  imageGalleryChange(index) {
    this.setState({ currentImgIndex: index })
  }

  // 打分
  score(data) {
    axios
      .post(`${API_HREF}/score`, data)
      .then((resp) => {
        message.success(this.t('rate_img_success'))
      })
      .catch((err) => {
        message.error(this.t('rate_img_failure'))
      })
  }
  rateChange(val) {
    const myRating = [...this.state.myRating]
    const humanRating = JSON.parse(JSON.stringify(this.state.humanRating))

    if (myRating[this.state.currentImgIndex] === -1 && humanRating[this.state.currentImgIndex]?.count > 5) {
      // 评分人数加一
      // 如果之前没有人工打分 则人工打分跟本人打分一致 评分人为1
      const item = humanRating[this.state.currentImgIndex] || {}
      item.count = item.count + 1
      item.score_all = item.score_all + val
      const score_average = item.score_all / item.count
      item.score_average = String(score_average).indexOf('.') > 0 ? score_average.toFixed(1) : score_average
      item.score_average = _.toNumber(item.score_average);
    }
    myRating[this.state.currentImgIndex] = val
    this.setState({ myRating, humanRating })
    this.imageGallery.current.slideToIndex(this.state.currentImgIndex)
    const data = {
      url: '',
      score: val,
      userid: this.state.userId, // 用户指纹
    }
    if (this.state.task?.num_images) {
      // data.url = `${API_HREF}/get-image/${this.state.task.qid}/${this.state.task.created_time}/${this.state.currentImgIndex}.jpg`
      data.url = `${IMG_URL}/cv2_${this.state.task.qid}_${this.state.task.created_time}_${this.state.currentImgIndex}.jpg`
    } else {
      data.url = `${this.state.recommendItems[this.state.currentImgIndex]['_id']}`
      if (data.url === 'undefined') {
        // 兼容ES中新的图片路径
        data.url = `${
          !this.state.recommendItems[this.state.currentImgIndex]['isEsSource']
            ? API_HREF + this.state.recommendItems[this.state.currentImgIndex]['original']
            : this.state.recommendItems[this.state.currentImgIndex]['original']
          }`
      }
    }
    this.score(data)
  }

  // 分页器
  onPaginationChange(page, pageSize) {
    this.setState({ historyPage: page })
  }
  handleContinue() {
    let url;
    if (this.state.recommendItems && this.state.recommendItems.length > 0) {
      url = this.state.recommendItems[this.state.currentImgIndex]['original']
    };
    if (this.state.task) {
      // url = `${API_HREF}/get-image/${this.state.task.qid}/${this.state.task.created_time}/${this.state.currentImgIndex}.jpg`
      url = `${IMG_URL}/cv2_${this.state.task.qid}_${this.state.task.created_time}_${this.state.currentImgIndex}.jpg`
    }
    if (url.split(':')[0] === 'https') {
      window.open(`http://192.168.6.203:8103/#link=${url}`, '_blank')
    } else {
      window.open(`http://192.168.6.203:8103/#link=https://wudao.aminer.cn/api/cogview${url}`, '_blank')
    }

    console.log(this.state.recommendItems[this.state.currentImgIndex]['original'])
  }

  renderLogin() {
    const currentQuery = this.state.query.trim() + (this.state.input_mode === '默认' ? '' : '，' + this.state.input_mode)
    const disabled = this.state.query.trim().length < 2 || this.state.username.trim().length === 0 || this.state.query.trim().length > 30
    return (
      <div className="login">
        <div className="logo" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/logo.png'})` }} />
        <div id="logo-description">{this.t('title')}</div>
        <Input.Group className="login-input">
          <Input
            size="large"
            placeholder={this.t('name_placeholder')}
            prefix={
              <div>
                <UserOutlined className="site-form-item-icon" />
                <span className="input-inner-header">{this.t('name_prompt')}</span>
              </div>
            }
            suffix={<ArrowRightOutlined className="btn" style={{ color: 'white' }} />}
            value={this.state.username}
            onChange={(e) => this.setState({ username: e.target.value })}
          />
        </Input.Group>
        <Input.Group className="login-input">
          <Input
            style={{ textAlign: 'center' }}
            size="large"
            placeholder={this.t('input_placeholder')}
            prefix={
              <div>
                <PictureOutlined className="site-form-item-icon" />
                <span className="input-inner-header">{this.t('input_prompt')}</span>
              </div>
            }
            suffix={
              <div>
                {this.state.enableTrans && (
                  <TranslationOutlined
                    className="enter-btn"
                    style={{ color: this.state.loading ? 'lightgray' : 'black' }}
                    onClick={() => this.translate()}
                  />
                )}
                <ArrowRightOutlined className="enter-btn" style={{ color: disabled ? 'lightgray' : 'black' }} onClick={() => this.generate()} />
              </div>
            }
            value={this.state.query}
            onChange={(e) => {
              this.detectTrans()
              this.setState({ query: e.target.value })
              this.getRecommendList(e.target.value)
            }}
            onPressEnter={() => this.generate()}
            addonAfter={
              <Select value={this.state.input_mode} onChange={(input_mode) => this.setState({ input_mode })}>
                {input_mode_ids.map((key, obj) => (
                  <Option key={key} value={texts[key].zh}>
                    {this.t(key)}
                  </Option>
                ))}
              </Select>
            }
          />
          <Dropdown trigger={['click']} visible={this.state.recommendListDropmenuVisible} placement="bottomLeft" overlay={
            <Menu onClick={this.handleMenuSelect.bind(this)} items={this.state.dropdownRecommendList}></Menu>
          }>
            <div></div>
          </Dropdown>
        </Input.Group>
        <div className="login-btns">
          <div className="prompt">
            <p>{this.t('warning_text')}</p>
          </div>
          {(this.state.task !== undefined && this.state.task.status === 'Succeed' && this.state.task.query === currentQuery) || (!this.state.task && this.state.isFirstIntoPageById) || (!this.state.task && this.state.isSelectedRecommendWd) ? (
            <Button className="wbtn login-btn" onClick={() => this.generate(true)} disabled={disabled}>
              {this.t('regenerate')}
            </Button>
          ) : (
              <Button className="wbtn login-btn" onClick={() => this.generate()} disabled={disabled}>
                {this.t('generate')}
              </Button>
            )}
          <Button className="wbtn history-display-btn" onClick={() => this.showHistory()}>
            {this.t('show_history')}
          </Button>
          <Button className="wbtn lang-btn" onClick={() => this.setState({ lang: this.state.lang === 'zh' ? 'en' : 'zh' })}>
            {this.t('switch_lang')}
          </Button>
          <Button className="wbtn github-btn" onClick={() => (window.location.href = 'https://github.com/THUDM/CogView')}>
            {this.t('github')}
          </Button>
        </div>
      </div>
    )
  }

  renderTask() {
    const task = this.state.task
    const status = task ? task.status : 'Not Found'
    const newTask = this.state.newTask
    return (
      <div className="contrast">
        <div className="task-display">
          {status === 'Not Found' && <Result status="warning" title={this.t('task_not_found')} subTitle={this.t('plz_regenerate')} />}
          {status === 'Fail' && <Result status="error" title={this.t('generate_fail')} subTitle={this.t('plz_regenerate_or_other')} />}
          {status === 'Created' && <Result icon={<SisternodeOutlined />} title={this.t('submitted_and_queue')} subTitle="" />}
          {status === 'Running' && <Result icon={<LoadingOutlined />} title={this.t('generating')} subTitle={this.t('generate_and_wait')} />}
          {status === 'Succeed' && (
            <div>
              <ImageGallery
                showIndex={true}
                showFullscreenButton={false}
                showPlayButton={false}
                items={_.range(task.num_images).map((key) => {
                  // const url = `${API_HREF}/get-image/${task.qid}/${task.created_time}/${key}.jpg`
                  const url = `${IMG_URL}/cv2_${task.qid}_${task.created_time}_${key}.jpg`

                  return { original: url, thumbnail: url, height: 96, width: 96 }
                })}
                ref={this.imageGallery}
                onSlide={(index) => this.imageGalleryChange(index)}
              />
              {task ? (
                <div key={this.state.currentImgIndex} className="rate">
                  {this.state.humanRating[this.state.currentImgIndex] && this.state.humanRating[this.state.currentImgIndex]?.count > 5 ? (
                    <div className="rate-item">
                      <span className="rate-type">{this.t('rate_img_human')}</span>
                      <span className="rate-value">{this.state.humanRating[this.state.currentImgIndex].score_average || 0}</span>
                      <Rate allowHalf disabled defaultValue={this.state.humanRating[this.state.currentImgIndex]['score_average']} />
                      <span className="rate-count">
                        {this.state.humanRating[this.state.currentImgIndex]['count'] || 0}
                        {this.t('rate_img_count')}
                      </span>
                    </div>
                  ) : null}
                  <div className="rate-item">
                    <span className="rate-type">{this.t('rate_img_user')}</span>
                    <span className="rate-value">
                      {this.state.myRating[this.state.currentImgIndex] === -1 ? '未评分' : this.state.myRating[this.state.currentImgIndex]}
                    </span>
                    <Rate
                      allowHalf
                      allowClear={false}
                      disabled={this.state.myRating[this.state.currentImgIndex] !== -1}
                      value={this.state.myRating[this.state.currentImgIndex]}
                      onChange={(val) => this.rateChange(val)}
                    />
                    <span className="rate-count" />
                    {continue_change && <Button onClick={this.handleContinue}>继续修改该图</Button>}
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
        {newTask?.images && status === 'Succeed' && <div className="new-task-display">
          <div className="display-legend">
            新版效果
            <Button className="enter-btn-new" onClick={() => (window.location.href = 'https://cogview.ai')}>体验入口</Button>
          </div>
           <div>
            <img src={newTask.images?.[0]} alt="" />
          </div>
        </div>}
      </div>
    )
  }

  renderDefaultPlay() {
    // console.log('renderDefaultPlay')

    return (
      <div className="task-display">
        <ImageGallery
          className="task-image-gallery"
          showIndex={true}
          startIndex={this.state.currentImgIndex}
          showFullscreenButton={false}
          showPlayButton={false}
          items={this.state.recommendItems.map((item) => {
            let url = item._id
            if (!url) {
              url = `${!item.isEsSource ? API_HREF + item.original : item.original}`
            }
            let description = item.query ? item.query : item.description

            return { ...item, description: description, original: url, thumbnail: url }
          })}
          ref={this.imageGallery}
          onSlide={(index) => this.imageGalleryChange(index)}
        />

        {this.state.recommendItems.length ? (
          <div key={this.state.currentImgIndex} className="rate">
            {this.state.humanRating[this.state.currentImgIndex] && this.state.humanRating[this.state.currentImgIndex]?.count > 5 ? (
              <div className="rate-item">
                <span className="rate-type">{this.t('rate_img_human')}</span>
                <span className="rate-value">{this.state.humanRating[this.state.currentImgIndex].score_average || 0}</span>
                <Rate allowHalf disabled defaultValue={this.state.humanRating[this.state.currentImgIndex]['score_average']} />
                <span className="rate-count">
                  {this.state.humanRating[this.state.currentImgIndex]['count'] || 0}
                  {this.t('rate_img_count')}
                </span>
              </div>
            ) : null}
            <div className="rate-item">
              <span className="rate-type">{this.t('rate_img_user')}</span>
              <span className="rate-value">
                {this.state.myRating[this.state.currentImgIndex] === -1 ? '未评分' : this.state.myRating[this.state.currentImgIndex]}
              </span>
              <Rate
                allowHalf
                allowClear={false}
                disabled={this.state.myRating[this.state.currentImgIndex] !== -1}
                value={this.state.myRating[this.state.currentImgIndex]}
                onChange={(val) => this.rateChange(val)}
              />
              <span className="rate-count" />
              {continue_change && <Button onClick={this.handleContinue}>继续修改该图</Button>}
            </div>
          </div>
        ) : null}
      </div>
    )
  }

  renderIcon(status) {
    if (status === 'Succeed') return <CheckCircleOutlined style={{ color: '#73d13d' }} />
    if (status === 'Fail') return <StopOutlined style={{ color: '#ff7a45' }} />
    if (status === 'Created') return <SisternodeOutlined style={{ color: '#40a9ff' }} />
    if (status === 'Running') return <LoadingOutlined style={{ color: '#36cfc9' }} />
    return <WarningOutlined style={{ color: '#ffec3d' }} />
  }

  renderHistory() {
    const { Search } = Input
    return (
      <Drawer
        title={
          <div className="history-title">
            <span>{this.t('history_records')}</span>
            <span style={{ marginBottom: '20px', textAlign: 'right', marginRight: '10px' }}>
              <Checkbox checked={this.state.my_history_checked} disabled={this.state.my_history_disabled} onChange={this.onMyHistoryChange}>
                {this.t('just_my_history')}
              </Checkbox>
            </span>
          </div>
        }
        placement="right"
        closable={true}
        onClose={() => this.setState({ displayHistory: false })}
        visible={this.state.displayHistory}
        width={'300px'}
      >
        <Search placeholder={this.t('search_text')} onSearch={(value) => this.onSearch(value)} style={{ width: '254px' }} />
        <List
          itemLayout="horizontal"
          dataSource={this.state.historyTasks}
          renderItem={(historyTask) => {
            return (
              <List.Item actions={[]}>
                <List.Item.Meta
                  className="history-item"
                  avatar={this.renderIcon(historyTask.status)}
                  title={historyTask.query}
                  description={
                    <div className="history-description">
                      <p>{`${this.t('author_prompt')}${historyTask.username}`}</p>
                      {historyTask?.score_best !== -1 && (
                        <p style={{ fontWeight: 500, color: '#333' }}>{`${this.t('rate_max_text')}${historyTask.score_best}`}</p>
                      )}
                      {/* <p>{`${this.t("create_time_prompt")}${this.datestr(historyTask.created_time)}`}</p> */}
                      <p>{`${this.t('generate_time_prompt')}${this.datestr(parseInt(historyTask.updated_time))}`}</p>
                      <p>{`${this.t('time_consuming_text')}${Math.round((historyTask.updated_time - historyTask.created_time) / 1000)}`}s</p>
                    </div>
                  }
                  onClick={() => {
                    if (this.poll_process) clearInterval(this.poll_process)
                    const parts = historyTask.query.split('，')
                    let query = historyTask.query
                    let input_mode = '默认'
                    if (parts.length > 0) {
                      let input_mode_id = _.find(input_mode_ids, (key) => texts[key].zh === parts[parts.length - 1])
                      if (input_mode_id !== undefined) {
                        input_mode = texts[input_mode_id].zh
                        query = query.slice(0, query.length - input_mode.length - 1)
                      }
                    }
                    const myRating = [-1, -1, -1, -1, -1, -1, -1, -1]
                    historyTask.score_list.forEach((item, index) => {
                      myRating[index] = item.score_user || -1
                    })
                    this.setState({
                      query,
                      input_mode,
                      task: historyTask,
                      displayHistory: false,
                      humanRating: historyTask.score_list,
                      myRating,
                      currentImgIndex: 0,
                      newTask:undefined,
                    })
                  }}
                />
              </List.Item>
            )
          }}
        />
        <div style={{ textAlign: 'center' }}>
          <Pagination
            size="small"
            simple
            current={this.state.historyPage}
            defaultPageSize={30}
            total={this.state.historyTotal}
            onChange={(page, pageSize) => this.onPaginationChange(page, pageSize)}
          />
        </div>
      </Drawer>
    )
  }

  renderWaitingList() {
    return (
      <div className="waiting-list">
        <Divider>
          {this.t('queue_list', { size: this.state.waitingTasks.length >= 20 ? '≥20' : this.state.waitingTasks.length })}
          {this.state.waitingTasks.length > 0 && this.t('queue_time', { size: this.state.waitingTime >= 15 ? '≥15' : this.state.waitingTime })}
        </Divider>
        <div className="items">
          {this.state.waitingTasks.map((waitingTask, idx) => {
            return (
              <div className="item" key={idx}>
                {this.renderIcon(waitingTask.status)}
                <div className="content">
                  <span className="title">{waitingTask.query}</span>
                  <br />
                  <span className="time">[{this.datestr(waitingTask.created_time)}]</span>
                  <span className="author">（{waitingTask.username}）</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  // 搜索推荐列表选择
  handleMenuSelect(e) {
    this.setState({ query: e.key, recommendListDropmenuVisible: false, isSelectedRecommendWd: true, task: undefined })
    this.getDefalutImgs(null, e.key)
  }

  // 获取推荐列表
  getRecommendList = _.debounce((wd) => {
    if (wd.length <= 0) {
      // 设置图片的风格
      this.setState({ input_mode: '高清摄影', isFirstIntoPageById: false, isSelectedRecommendWd: false, query: wd, task: undefined, dropdownRecommendList: [], recommendListDropmenuVisible: false })
      return
    }
    // 获取推荐词列表
    axios.get(`${ES_API_SERVER}/wudao/keyword/recommend-list?type=cogview&total=10&wd=${wd}`).then((res) => {
      if (res.data.code !== '0') {
        return message.error(this.t('service_err', { err: '从ES中获取cogview数据失败' }))
      }
      let dropdownRecommendList = res.data.data.keywordList.map((item) => { return { key: item, label: item } })
      this.setState({ dropdownRecommendList: dropdownRecommendList, recommendListDropmenuVisible: dropdownRecommendList.length > 0 ? true : false, isSelectedRecommendWd: false, task: undefined })
    }).catch(err => {
      message.error(this.t('service_err', { err: '从ES中获取cogview数据失败' }))
    })

  }, 500)

  // 全局事件监听
  handleMouseUp(e) {
    console.log("事件被监听了", 'task=> ', this.state.task, 'isSelectedWd => ', this.state.isSelectedRecommendWd, 'isFirstIntoPageById => ', this.state.isFirstIntoPageById, 'query => ', this.state.query)
    // 隐藏搜索下拉菜单
    this.setState({ recommendListDropmenuVisible: false })
  }

  render() {
    return (
      <div className="App" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`, backgroundSize: 'cover' }}>
        <div className="App-background" />
        <div className="App-inner">
          {this.state.model === 'login' && this.renderLogin()}
          {this.state.task && this.renderTask()}
          {!this.state.task && this.renderDefaultPlay()}
          {this.renderWaitingList()}
        </div>
        {this.renderHistory()}
        {this.state.loading && (
          <div className="loading-mask">
            <div className="mask-inner">
              <LoadingOutlined />
            </div>
          </div>
        )}
      </div>
    )
  }
}